import { makeBetterEnum } from './betterEnum';

export const BuildingSizeUnit = makeBetterEnum('SquareFeet', 'SquareMeters');

export type BuildingSizeUnit =
  (typeof BuildingSizeUnit)[keyof typeof BuildingSizeUnit];

export const BuildingLeaseType = makeBetterEnum(
  'Owned',
  'Leased',
  'DownstreamLeasePayingUtilities',
  'DownstreamLeaseNotPayingUtilities',
  'DownstreamSubleasePayingUtilities',
  'DownstreamSubleaseNotPayingUtilities',
  'UpstreamSublease',
  'CoworkingOrServicedOffice',
  'Franchise',
  'SoldBuilding',
  'Unknown'
);

export type BuildingLeaseType =
  (typeof BuildingLeaseType)[keyof typeof BuildingLeaseType];

export const BuildingEditState = makeBetterEnum(
  'Partial',
  'Full',
  'NeedsConfirmation'
);

export type BuildingEditState =
  (typeof BuildingEditState)[keyof typeof BuildingEditState];

export const BuildingPeriodKind = makeBetterEnum(
  'BuildingSize',
  'CleanPower',
  'IsBuildingEmpty',
  'CustomField',
  'PowerUsageEffectiveness',
  'OrgUnit'
);

export type BuildingPeriodKind =
  (typeof BuildingPeriodKind)[keyof typeof BuildingPeriodKind];

export const BuildingUtilityUnit = makeBetterEnum(
  'M3NaturalGas',
  'Kbtu',
  'Mmbtu',
  'Therm',
  'Ccf',
  'Mcf',
  'Cf',
  'Gj',
  'Mj',
  'Oz',
  'Gallons',
  'Liter',
  'Kwh',
  'Kw',
  'Joule',
  'G',
  'Kg',
  'Lb',
  'Tonnes',
  'Tons',
  'CubicMeter',
  'Kilogallon',
  'Centigallon',
  'RTh'
);

export type BuildingUtilityUnit =
  (typeof BuildingUtilityUnit)[keyof typeof BuildingUtilityUnit];

export const BuildingWasteUnit = makeBetterEnum(
  'G',
  'Kg',
  'Lb',
  'Tonnes',
  'Tons'
);

export type BuildingWasteUnit =
  (typeof BuildingWasteUnit)[keyof typeof BuildingWasteUnit];

export const BuildingUtilityType = makeBetterEnum(
  'ElectricityConsumption',
  'StationaryCombustion',
  'Cooling',
  'Waste',
  'Water',
  'Refrigerant'
);

export type BuildingUtilityType =
  (typeof BuildingUtilityType)[keyof typeof BuildingUtilityType];

export const AdeFacilitiesSurveyStatus = makeBetterEnum(
  'Unknown',
  'NotFacilitiesAdt',
  'Stale',
  'UpToDate'
);

export type AdeFacilitiesSurveyStatus =
  (typeof AdeFacilitiesSurveyStatus)[keyof typeof AdeFacilitiesSurveyStatus];
